
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import ClaimListComponent from '../../components/ClaimListComponent/ClaimListComponent';
import metadata from './ClaimList.metadata.json5';
import styles from './ClaimList.module.scss';

function ClaimList() {
    const overrides = {};
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            claimlistcomponent: ClaimListComponent
        }
    };

    return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
}

export default withRouter(ClaimList);
